<template>
  <div id="video-intro">
    <div class="wrap">
      <div class="text-block">
        <el-upload action=""
                   :multiple="false"
                   :show-file-list="false"
                   accept=".mp4"
                   :http-request="uploadFileToFast">
          <el-button type="button"
                     v-if="resObj.showButton==1"
                     :loading="uploading">Upload the video</el-button>
        </el-upload>
        <div class="text">
          Self-Introduction Video requirements:<br>
          1.Video Format: .MP4，document size：less than 30 MB<br>
          2.20-30seconds<br>
          3.Quiet background<br>
          4.Waist shot<br>
          5.HD camera<br>
          <span style="color:red">tips：Before uploading，please use the tool to process your video</span>
        </div>
      </div>
      <div class="video-block">
        <video :src="resObj.videoUrl"
               controls></video>
      </div>
    </div>
    <div class="exam-block">
      <span class="show-examine">{{resObj.auditStatus | getExamText}}</span>
      <span style="color:red"
            class="exam-remark"
            v-if="resObj.auditStatus==2">({{resObj.auditRemark}})</span>
    </div>
    <el-button class="submit-btn"
               v-if="resObj.showButton==1"
               :loading='submitLoading'
               @click="submit()">submit</el-button>
  </div>
</template>
<script>
import './index.less';
export default {
  created() {
    this.getInfo();
  },
  data() {
    return {
      resObj: {},
      preViewUrl: '',
      uploading: false,
      uploadUrl: '',
      submitLoading: false,
    };
  },
  filters: {
    getExamText(val) {
      if (val === 0) {
        return 'apply for approval';
      } else if (val === 1) {
        return 'approved';
      } else if (val === 2) {
        return 'disapproved';
      }
    },
  },
  methods: {
    async getInfo() {
      const res = await this.$api.getProfileVideo();
      this.resObj = res.data.resultData;
    },
    async uploadFileToFast(file) {
      const isLt30M = file.file.size / 1024 / 1024 < 30;
      if (!isLt30M) {
        this.$message.error('Wrong Format,Must less than 30MB!');
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      //与发送资料的接口相同
      try {
        this.uploading = true;
        const res = await this.$api.uploadFile(formData);
        this.$alert('Upload Success!', 'Notice', {
          confirmButtonText: 'Ok',
          customClass: 'notice-message',
          callback: (action) => {},
        });
        this.uploading = false;
        this.resObj.videoUrl = res.data.resultData.downloadUrl;
        this.uploadUrl = res.data.resultData.fileUrl;
      } catch (e) {
        this.uploading = false;
        console.log(e);
      }
    },
    async submit() {
      if (this.uploadUrl) {
        this.submitLoading = true;
        let params = { videoUrl: this.uploadUrl };
        try {
          await this.$api.putProfileVideo(params);
          this.getInfo();
        } catch (e) {
          console.log(e);
        }
        this.submitLoading = false;
      } else {
        this.$message({
          message: 'Please upload the video',
          center: true,
          type: 'warning',
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/global-components/ModifyInfo/VideoIntro/index.vue